<template>
  <div class="layouts">
    <div class="home-mobile">
      <div class="content">
        <div class="wallet-img">
          <img src="../assets/images/wallet.svg" alt="">
        </div>
        <div class="wallet-title">Connect your wallet</div>
        <div class="wallet-info">Please use a decentralized application to access.</div>
        <div class="confirm-button" @click="connect">Connect wallet</div>
      </div>
    </div>
  </div>

</template>

<script type="text/javascript">
export default {
  data() {
    return {
      apiSer: "",
    }
  },

  methods: {
    connect(){
      var web3= null
      var account = null
      var isMetaMaskConnected =false
      const connectMetaMask = async () => {
        if (window.ethereum) {
          try {
            // 请求用户授权
            await window.ethereum.request({ method: 'eth_requestAccounts' });
            // 动态导入 web3.js
            const Web3 = (await import('web3')).default;
            // 初始化 web3 实例
            web3 = new Web3(window.ethereum);
            // 获取用户账户
            const accounts = await web3.eth.getAccounts();
            var account = accounts[0];
            console.log('Connected account:', account);
            isMetaMaskConnected = true;
          } catch (error) {
            console.error('User denied account access', error);
          }
        } else {
          // alert('MetaMask not detected. Please install MetaMask.');
          console.log('MetaMask not detected');
        }
      };
      connectMetaMask()
    },
  }
}
</script>


<style>
.layouts{
  background: #000;
  color: #fff;
  height: 100%;
  padding: 0 20px;
}
.home-mobile{
  width: 100%;
  line-height: 100%;
  height: 100vh;
  display: flex;
  background: #000;
  align-content: center;
  align-items: center;
}
.home-mobile .content{
  width: 100%;
}
.home-mobile .content .wallet-img {
  width: 150px;
  height: 140px;
  margin: auto;
}
.home-mobile .content .wallet-img img {
  width: 100%;
  height: 100%;
}
.home-mobile .content .wallet-title {
  margin-top: 40px;
  text-align: center;
  letter-spacing: .0075em;
  font-feature-settings: "tnum" on,"lnum" on;
  color: #fff;
  font-weight: 600;
  font-size:24px;
  height: 34px;
}
.home-mobile .content .wallet-info {
  width: calc(100% - 40px);
  margin: auto;
  font-weight: 400;
  font-size: 14px;
  text-align: center;
  letter-spacing: .0075em;
  font-feature-settings: "tnum" on,"lnum" on;
  color: hsla(0,0%,100%,.3);
  margin-top: 6px;
}
.home-mobile .content .confirm-button {
  font-weight: 600;
  font-size: 16px;
  width: 100%;
  height: 48px;
  background: #c0dd2b;
  border-radius: 13px;
  text-align: center;
  line-height: 48px;
  margin-top: 24px;
}
</style>
